<template>
  <ListComponent
    v-if="transactions.length"
    v-slot="slotData"
    class="relative h-full overflow-auto"
    :itemContainerHeight="70"
    itemContainerWidth="100%"
    :itemsClasses="[]"
    directUseItems
    :allItems="transactions"
    scrollContainerSelector=""
    id="lol"
    ref="list"
    :loadingMoreEnd="false"
  >
    <div
      v-if="slotData"
      class="px-6 flex h-full items-center ripple"
      @click="showTransactionDetails(slotData.data.item)"
    >
      <div
        class="flex gap-4 items-center w-full"
        v-if="slotData.data?.item?.reference || slotData.data?.item?.shimmer"
        :class="{
          shimmerElement: slotData.data.item.shimmer,
        }"
      >
        <div class="w-16 h-16 rounded-2xl overflow-hidden relative">
          <div class="gradient-border border-sm !opacity-30"></div>
          <img
            v-if="
              slotData?.data?.item?.metaData?.dst?.metadata?.subscription
                ?.metadata?.image ||
              slotData?.data?.item?.metaData?.src?.metadata?.card?.metadata
                ?.image ||
              slotData?.data?.item?.metaData?.dst?.metadata?.card?.metadata
                ?.image
            "
            :src="
              slotData?.data?.item?.metaData?.dst?.metadata?.subscription
                ?.metadata?.image ||
              slotData?.data?.item?.metaData?.src?.metadata?.card?.metadata
                ?.image ||
              slotData?.data?.item?.metaData?.dst?.metadata?.card?.metadata
                ?.image
            "
            alt=""
            class="w-full h-full object-contain"
          />
          <img
            v-else
            :src="
              logos[slotData.data.item.operationType || 'kingrecharge'] ||
              logos.kingrecharge
            "
            class="w-full h-full"
          />
        </div>
        <div class="pt-2">
          <div class="text-lg title-text-white font-bold">
            {{ slotData.data.item.operationNameDisplay }}
          </div>
          <div class="font-medium text-slate-300 -top-1 relative">
            {{ slotData.data.item.startDate }}
          </div>
        </div>
        <div class="ml-auto text-end text-white">
          <div class="font-bold">
            {{ slotData.data.item.amountToReceive }}
            {{ slotData.data.item.currencyToReceive }}
          </div>
          <div class="-top-1 relative-top-1 text-slate-300 relative">
            {{ $t('transactions.list.status.' + slotData.data.item.status) }}
          </div>
        </div>
      </div>
    </div>
  </ListComponent>
  <div class="w-full h-full flex items-center justify-center" v-else>
    <div class="w-2/3 pb-64 pt-32">
      <LottieComponent content="emptyTransactions" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListComponent from '../utils/ListComponentVirtualScroll.vue'
import LottieComponent from '../utils/LottieComponent.vue'

import kingrechargeLogo from '@/assets/images/all/logo-dard-bg.svg'
import xbetLogo from '@/assets/images/services/1xBetIco.svg'
import oneWin from '@/assets/images/all/1winIcon.svg'
import betwinnerLogo from '@/assets/images/all/betwinner.png'
import melbetLogo from '@/assets/images/all/melbetIcon.svg'
import eightStarzLogo from '@/assets/images/all/eightStarz.png'
import usdtLogo from '@/assets/images/all/usdtIcon.svg'
import giftCardLogo from '@/assets/images/all/gift-card-with-bg.svg'

export default defineComponent({
  name: 'TransactionListComponent',
  components: { ListComponent, LottieComponent },
  props: {
    sourceData: {
      type: String,
      default: 'transactions',
    },
    updateEventToListen: {
      type: String,
      default: 'transactions_updated',
    },
  },
  data() {
    return {
      shimmerTransactions: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      transactions: [],
      eventsIds: [],
      logos: {
        kingrecharge: kingrechargeLogo,
        [`1xbet`]: xbetLogo,
        betwinner: betwinnerLogo,
        melbet: melbetLogo,
        eightStarz: eightStarzLogo,
        [`1Win`]: oneWin,
        usdt: usdtLogo,
        giftcard: giftCardLogo,
      },
    }
  },
  mounted() {
    // return;
    this.transactions = JSON.parse(JSON.stringify(this.shimmerTransactions))
    this.loadTransactions()
    const id = this.$Events.handleEvent(
      this.updateEventToListen,
      this.loadTransactions,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
    this.unsubscribeToResponseListener()
  },
  methods: {
    async loadTransactions() {
      this.unsubscribeToResponseListener()
      const { unsubscribe } = this.$Events.sendDataRequest(
        this.sourceData,
        this.onTransactionsGot,
      )
      this.unsubscribeToResponseListener = unsubscribe
    },
    unsubscribeToResponseListener() {},
    onTransactionsGot(transactions) {
      if (!transactions) return
      this.transactions = transactions
      // this.transactions = Object.freeze(transactions)
    },
    showTransactionDetails(transaction) {
      if (!transaction || !transaction?.reference) return
      this.$Events.dispatchEvent('transaction_details_requested_bottomsheet', {
        reference: transaction.reference,
      })
    },
  },
})
</script>
